import React from "react";

export default ({ className }) => (
  <svg className={className} fill="none" viewBox="0, 0, 400,341.09589041095893">
    <path
      fill="currentColor"
      d="M43.434 81.552 C 24.696 88.429,15.441 109.888,23.584 127.578 C 29.217 139.814,168.621 291.690,177.874 295.670 C 195.231 303.137,207.115 298.661,226.713 277.276 C 234.247 269.055,240.733 262.021,241.127 261.644 C 241.521 261.267,251.062 250.788,262.329 238.356 C 273.596 225.925,283.151 215.445,283.562 215.068 C 283.973 214.692,293.528 204.212,304.795 191.781 C 316.062 179.349,328.122 166.096,331.594 162.329 C 362.546 128.747,362.329 129.086,362.329 114.452 C 362.329 98.149,354.406 86.686,339.503 81.428 C 331.300 78.534,51.338 78.651,43.434 81.552 "
    />
  </svg>
);
